import React from 'react';
import { BanknoteIcon, ClockIcon, CheckCircle2Icon, TrendingUpIcon } from 'lucide-react';
interface StatsBarProps {
  totalFunded: number;
  pendingFollowUps: number;
  completedThisMonth: number;
  avgRate: string;
}
export function StatsBar({
  totalFunded,
  pendingFollowUps,
  completedThisMonth,
  avgRate
}: StatsBarProps) {
  return <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-115">
      <div className="bg-white rounded-xl border border-gray-100 p-4 shadow-sm" data-id="element-116">
        <div className="flex items-center gap-3" data-id="element-117">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-blue-50" data-id="element-118">
            <BanknoteIcon className="w-5 h-5 text-blue-600" data-id="element-119" />
          </div>
          <div data-id="element-120">
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-121">
              Total Funded
            </p>
            <p className="text-2xl font-bold text-gray-900" data-id="element-122">{totalFunded}</p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-gray-100 p-4 shadow-sm" data-id="element-123">
        <div className="flex items-center gap-3" data-id="element-124">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-amber-50" data-id="element-125">
            <ClockIcon className="w-5 h-5 text-amber-600" data-id="element-126" />
          </div>
          <div data-id="element-127">
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-128">
              Pending Follow-Ups
            </p>
            <p className="text-2xl font-bold text-gray-900" data-id="element-129">
              {pendingFollowUps}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-gray-100 p-4 shadow-sm" data-id="element-130">
        <div className="flex items-center gap-3" data-id="element-131">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-emerald-50" data-id="element-132">
            <CheckCircle2Icon className="w-5 h-5 text-emerald-600" data-id="element-133" />
          </div>
          <div data-id="element-134">
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-135">
              Completed
            </p>
            <p className="text-2xl font-bold text-gray-900" data-id="element-136">
              {completedThisMonth}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-gray-100 p-4 shadow-sm" data-id="element-137">
        <div className="flex items-center gap-3" data-id="element-138">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-violet-50" data-id="element-139">
            <TrendingUpIcon className="w-5 h-5 text-violet-600" data-id="element-140" />
          </div>
          <div data-id="element-141">
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-142">
              Avg Rate
            </p>
            <p className="text-2xl font-bold text-gray-900" data-id="element-143">{avgRate}</p>
          </div>
        </div>
      </div>
    </div>;
}